import { Image } from '@/types/image.type';
import { Link } from '@/types/link.type';

import { getClutchReviewUrl } from './review-platforms.config';

export type ReviewTextKey =
  | 'testimonials.teoPetricevic.quote'
  | 'testimonials.ivanaVuka.quote'
  | 'testimonials.steffVanDerBerg.quote'
  | 'testimonials.ashleyWard.quote'
  | 'testimonials.markoBaricevic.quote'
  | 'testimonials.anaPelicaric.quote'
  | 'testimonials.toniLabor.quote'
  | 'testimonials.anonymousBoatBooking.quote'
  | 'testimonials.lanaUgrcic.quote'
  | 'testimonials.miljenkoMarinic.quote'
  | 'testimonials.izidorAbdulmar.quote'
  | 'testimonials.jakovKusic.quote'
  | 'testimonials.nikolaBalic.quote'
  | 'testimonials.eleonoraMandic.quote'
  | 'testimonials.lukaColnago.quote'
  | 'testimonials.markoMadarevic.quote'
  | 'testimonials.katarinaZrno.quote'
  | 'testimonials.dragoKacunic.quote'
  | 'testimonials.rokoKacunic.quote'
  | 'testimonials.anonymousMedicalDevices.quote'
  | 'testimonials.borisJuric.quote'
  | 'testimonials.zojaStevovic.quote'
  | 'testimonials.damirKovacevic.quote'
  | 'testimonials.ivicaZuro.quote'
  | 'testimonials.josipMamic.quote'
  | 'testimonials.markoKovacevic.quote';

export interface Review {
  id: string;
  quote: ReviewTextKey;
  author: string;
  role: string;
  avatar?: Image;
  link: Link;
  rating: number;
  featured?: boolean;
}

export const reviews: Review[] = [
  {
    id: 'testimonial-1',
    quote: 'testimonials.ashleyWard.quote',
    author: 'Ashley Ward',
    role: 'Content & Social Media Executive @Sailweek',
    avatar: {
      src: '/images/testimonials/ashley-ward.png',
      alt: 'Ashley Ward',
    },
    link: {
      href: getClutchReviewUrl('421629'),
      text: 'testimonials.readMoreOnClutch',
      target: '_blank',
    },
    rating: 5.0,
  },
  {
    id: 'testimonial-2',
    quote: 'testimonials.borisJuric.quote',
    author: 'Boris Juric',
    role: 'CCO @Powerplay One',
    link: {
      href: getClutchReviewUrl('468618'),
      text: 'testimonials.readMoreOnClutch',
      target: '_blank',
    },
    rating: 5.0,
  },
  {
    id: 'testimonial-3',
    quote: 'testimonials.ivanaVuka.quote',
    author: 'Ivana Vuka',
    role: 'Head of Technology Transfer Office @University of Split',
    avatar: {
      src: '/images/testimonials/ivana-vuka.png',
      alt: 'Ivana Vuka',
    },
    link: {
      href: getClutchReviewUrl('324102'),
      text: 'testimonials.readMoreOnClutch',
      target: '_blank',
    },
    rating: 5.0,
  },
  {
    id: 'testimonial-4',
    quote: 'testimonials.teoPetricevic.quote',
    author: 'Teo Petričević',
    role: 'CEO @Capax',
    avatar: {
      src: '/images/testimonials/teo-petricevic.png',
      alt: 'Teo Petričević',
    },
    link: {
      href: getClutchReviewUrl('290391'),
      text: 'testimonials.readMoreOnClutch',
      target: '_blank',
    },
    rating: 4.5,
    featured: true,
  },
  {
    id: 'testimonial-5',
    quote: 'testimonials.steffVanDerBerg.quote',
    author: 'Steff van der Berg',
    role: 'Head of Sales @Cata Sailing',
    avatar: {
      src: '/images/testimonials/steff-van-der-berg.png',
      alt: 'Steff van der Berg',
    },
    link: {
      href: getClutchReviewUrl('325678'),
      text: 'testimonials.readMoreOnClutch',
      target: '_blank',
    },
    rating: 4.5,
  },
  {
    id: 'testimonial-6',
    quote: 'testimonials.dragoKacunic.quote',
    author: 'Drago Kacunic',
    role: 'COO @Capax',
    link: {
      href: getClutchReviewUrl('287039'),
      text: 'testimonials.readMoreOnClutch',
      target: '_blank',
    },
    rating: 5.0,
  },
  {
    id: 'testimonial-7',
    quote: 'testimonials.nikolaBalic.quote',
    author: 'Nikola Balic',
    role: 'Head of Science & Innovation @University of Split',
    link: {
      href: getClutchReviewUrl('295742'),
      text: 'testimonials.readMoreOnClutch',
      target: '_blank',
    },
    rating: 5.0,
  },
  {
    id: 'testimonial-8',
    quote: 'testimonials.markoBaricevic.quote',
    author: 'Marko Baričević',
    role: 'Head of Technical Dept & Investment Projects, DES',
    avatar: {
      src: '/images/testimonials/marko-baricevic.webp',
      alt: 'Marko Baričević',
    },
    link: {
      href: getClutchReviewUrl('429871'),
      text: 'testimonials.readMoreOnClutch',
      target: '_blank',
    },
    rating: 5.0,
    featured: true,
  },
  {
    id: 'testimonial-9',
    quote: 'testimonials.lanaUgrcic.quote',
    author: 'Lana Ugrcic',
    role: 'Senior Advisor @Technology Park Split',
    link: {
      href: getClutchReviewUrl('434608'),
      text: 'testimonials.readMoreOnClutch',
      target: '_blank',
    },
    rating: 5.0,
  },
  {
    id: 'testimonial-10',
    quote: 'testimonials.izidorAbdulmar.quote',
    author: 'Izidor Abdulmar',
    role: 'CEO & Founder @Pro Desk',
    link: {
      href: getClutchReviewUrl('435739'),
      text: 'testimonials.readMoreOnClutch',
      target: '_blank',
    },
    rating: 5.0,
  },
  {
    id: 'testimonial-11',
    quote: 'testimonials.miljenkoMarinic.quote',
    author: 'Miljenko Marinic',
    role: 'CEO @Booker',
    link: {
      href: getClutchReviewUrl('455044'),
      text: 'testimonials.readMoreOnClutch',
      target: '_blank',
    },
    rating: 5.0,
  },
  {
    id: 'testimonial-12',
    quote: 'testimonials.zojaStevovic.quote',
    author: 'Zoja Stevovic',
    role: 'Managing Director @Kancelarija',
    link: {
      href: getClutchReviewUrl('500987'),
      text: 'testimonials.readMoreOnClutch',
      target: '_blank',
    },
    rating: 5.0,
  },
  {
    id: 'testimonial-13',
    quote: 'testimonials.damirKovacevic.quote',
    author: 'Damir Kovačević',
    role: 'CEO @Brainit',
    link: {
      href: getClutchReviewUrl('474875'),
      text: 'testimonials.readMoreOnClutch',
      target: '_blank',
    },
    rating: 5.0,
  },
  {
    id: 'testimonial-14',
    quote: 'testimonials.ivicaZuro.quote',
    author: 'Ivica Zuro',
    role: 'Founder & Business Owner @MM Beneficium',
    link: {
      href: getClutchReviewUrl('464422'),
      text: 'testimonials.readMoreOnClutch',
      target: '_blank',
    },
    rating: 5.0,
  },
  {
    id: 'testimonial-15',
    quote: 'testimonials.josipMamic.quote',
    author: 'Josip Mamic',
    role: 'Managing Director @PETKUS Design',
    link: {
      href: getClutchReviewUrl('462912'),
      text: 'testimonials.readMoreOnClutch',
      target: '_blank',
    },
    rating: 5.0,
  },
  {
    id: 'testimonial-16',
    quote: 'testimonials.markoKovacevic.quote',
    author: 'Marko Kovacevic',
    role: 'Technician & Consultant @PRIME CLIENT',
    link: {
      href: getClutchReviewUrl('459547'),
      text: 'testimonials.readMoreOnClutch',
      target: '_blank',
    },
    rating: 5.0,
  },
];
